/**
 * @generated SignedSource<<70eff0982fe78360917064ef43a2f4cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedSkinnyBannerModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_user">;
  readonly " $fragmentType": "HpSharedSkinnyBannerModule_user";
};
export type HpSharedSkinnyBannerModule_user$key = {
  readonly " $data"?: HpSharedSkinnyBannerModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedSkinnyBannerModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedSkinnyBannerModule_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useCoreBuyerIncentives_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f0d75ab2f115afc897fafc3ae96e61b9";

export default node;
